export default __webpack_public_path__ + "static/paquete-aa8bd513b507455ba83b699dc70545e4.png";